export enum CurrentStatusFlag {
  Open = "Open",
  Closed = "Closed",
  OutofCoverage = "OutofCoverage",
  Suspended = "Suspended",
  TempClosed = "TempClosed",
  Offline = "Offline"
}
